import thresholdsReducer from "./thresholdsSlice";

export default thresholdsReducer;
